module.exports = __webpack_public_path__ + "img/arrow-prev.c16ad51d.svg";